import { IpNames } from "../../interfaces/interfaces";

export type EmailClientType = 'gmail' | 'outlook';
export type DisplaySeparator = 'OR' | 'AND' | ',' | '';

interface SeparatorConditions {
	shouldJoin: boolean;
	displaySeparator: DisplaySeparator;
}

interface IpEmailClientConfig {
	separatorConditions: SeparatorConditions;
	fieldLabel?: string;
}

interface IpEmailConfig {
	gmail?: IpEmailClientConfig;
	outlook?: IpEmailClientConfig;
}

export const IP_EMAIL_CONFIG: Record<string, IpEmailConfig> = {
	[IpNames.nykaa]: {
		gmail: {
			separatorConditions: {
				shouldJoin: true,
				displaySeparator: 'OR',
			},
		},
		outlook: {
			separatorConditions: {
				shouldJoin: false,
				displaySeparator: '',
			},
		},
	},
	[IpNames.swiggyInstamart]: {
		gmail: {
			separatorConditions: {
				shouldJoin: true,
				displaySeparator: 'OR',
			},
		},
		outlook: {
			separatorConditions: {
				shouldJoin: false,
				displaySeparator: '',
			},
		},
	},
	[IpNames.flipkartSeller]: {
		gmail: {
			separatorConditions: {
				shouldJoin: false,
				displaySeparator: '',
			},
			fieldLabel: 'Has the words',
		},
		outlook: {
			separatorConditions: {
				shouldJoin: true,
				displaySeparator: 'AND',
			},
			fieldLabel: 'Subject or body includes',
		},
	},
};

export const formatNoReplyEmail = (
	email: string | undefined,
	companyName: string,
	emailType: EmailClientType
): string => {
	if (!email) return '';

	const config = IP_EMAIL_CONFIG[companyName]?.[emailType];
	const { shouldJoin, displaySeparator } = config?.separatorConditions ?? { shouldJoin: false, displaySeparator: '' };

	if (shouldJoin && displaySeparator) {
		return email.split(',').map(e => e.trim()).join(` ${displaySeparator} `);
	}

	return email;
};

export const getEmailFieldLabel = (
	companyName: string,
	emailType: EmailClientType
): string => {
	return IP_EMAIL_CONFIG[companyName]?.[emailType]?.fieldLabel ?? 'From';
};

export const getEmailDisplaySeparator = (
	companyName: string,
	emailType: EmailClientType = 'outlook'
): DisplaySeparator => {
	const config = IP_EMAIL_CONFIG[companyName]?.[emailType];
	return config?.separatorConditions?.displaySeparator ?? '';
};

export const usesHasTheWordsField = (companyName: string): boolean => {
	return getEmailFieldLabel(companyName, 'gmail') === 'Has the words';
};

export const usesSubjectOrBodyField = (companyName: string): boolean => {
	return getEmailFieldLabel(companyName, 'outlook') === 'Subject or body includes';
};
